import { LogoutIcon } from 'de-suite-me-ui'

export default LogoutIcon
